export default __webpack_public_path__ + "static/media/chat-client.9b365f23.svg";